(function () {
  if (typeof Swiper === "undefined") return;

  var LOOP_MIN_SLIDES = 6;

  function autoplayDelay(el, fallback) {
    if (!el) return fallback;
    var n = parseInt(el.getAttribute("data-autoplay-delay"), 10);
    return !isNaN(n) && n >= 500 ? n : fallback;
  }

  function swiperSlideCount(el) {
    return el ? el.querySelectorAll(".swiper-slide").length : 0;
  }

  function normalizeNavEl(el) {
    if (!el) return null;
    if (el.nodeType === 1) return el;
    if (el.length && el[0] && el[0].nodeType === 1) return el[0];
    return null;
  }

  function attachNavVisibility(swiper) {
    function sync() {
      var locked =
        swiper.isLocked === true ||
        (swiper.el && swiper.el.classList.contains("swiper-lock"));
      var nextEl = normalizeNavEl(swiper.navigation.nextEl);
      var prevEl = normalizeNavEl(swiper.navigation.prevEl);
      if (nextEl) nextEl.style.display = locked ? "none" : "";
      if (prevEl) prevEl.style.display = locked ? "none" : "";
    }
    swiper.on("resize", sync);
    swiper.on("breakpoint", sync);
    swiper.on("slideChange", sync);
    swiper.on("update", sync);
    sync();
    setTimeout(function () {
      swiper.update();
      sync();
    }, 0);
  }

  function newReleasesStyleOptions(el, nextSelector, prevSelector) {
    var count = swiperSlideCount(el);
    var useLoop = count >= LOOP_MIN_SLIDES;
    return {
      autoplay:
        count <= 1
          ? false
          : {
              delay: autoplayDelay(el, 3000),
              disableOnInteraction: false,
            },
      slidesPerView: 5,
      slidesPerGroup: 1,
      grabCursor: true,
      loop: useLoop,
      a11y: false,
      spaceBetween: 28,
      allowTouchMove: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      navigation: {
        nextEl: nextSelector,
        prevEl: prevSelector,
      },
      breakpoints: {
        0: {
          slidesPerView: 2.2,
          slidesPerGroup: 1,
          spaceBetween: 28,
        },
        480: {
          slidesPerView: 2.5,
          slidesPerGroup: 1,
          spaceBetween: 28,
        },
        767: {
          slidesPerView: 4.2,
          slidesPerGroup: 1,
          spaceBetween: 28,
        },
        992: {
          slidesPerView: 5,
          slidesPerGroup: 1,
          spaceBetween: 28,
        },
      },
    };
  }

  var basicEl = document.querySelector("#basic-swiper");
  if (basicEl) {
    var basicSwiper = new Swiper(
      basicEl,
      newReleasesStyleOptions(basicEl, "#right-button", "#left-button")
    );
    attachNavVisibility(basicSwiper);
  }

  function artistReleasesStyleOptions(el, nextSelector, prevSelector) {
    var opts = newReleasesStyleOptions(el, nextSelector, prevSelector);
    var count = parseInt(el.getAttribute("data-artist-release-count"), 10);
    if (isNaN(count)) count = swiperSlideCount(el);
    if (count < LOOP_MIN_SLIDES) {
      opts.loop = false;
    }
    if (count <= 1) {
      opts.autoplay = false;
    }
    opts.centerInsufficientSlides = true;
    return opts;
  }

  document.querySelectorAll('[id^="artist-releases-swiper-"]').forEach(function (el) {
    var suffix = el.id.replace(/^artist-releases-swiper-/, "");
    var arSwiper = new Swiper(
      el,
      artistReleasesStyleOptions(
        el,
        "#artist-releases-right-" + suffix,
        "#artist-releases-left-" + suffix
      )
    );
    attachNavVisibility(arSwiper);
  });

  function merchSwiperOptions(el, nextSelector, prevSelector, centerInsufficientSlides) {
    var count = swiperSlideCount(el);
    var useLoop = count >= LOOP_MIN_SLIDES;
    return {
      autoplay:
        count <= 1
          ? false
          : {
              delay: autoplayDelay(el, 3000),
              disableOnInteraction: false,
            },
      slidesPerView: 5,
      slidesPerGroup: 1,
      grabCursor: true,
      loop: useLoop,
      a11y: false,
      spaceBetween: 28,
      allowTouchMove: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      centerInsufficientSlides: centerInsufficientSlides === true,
      navigation: {
        nextEl: nextSelector,
        prevEl: prevSelector,
      },
      breakpoints: {
        0: {
          slidesPerView: 2.2,
          slidesPerGroup: 1,
          spaceBetween: 28,
        },
        480: {
          slidesPerView: 2.5,
          slidesPerGroup: 1,
          spaceBetween: 28,
        },
        767: {
          slidesPerView: 4.2,
          slidesPerGroup: 1,
          spaceBetween: 28,
        },
        992: {
          slidesPerView: 5,
          slidesPerGroup: 1,
          spaceBetween: 28,
        },
      },
    };
  }

  var merchEl = document.querySelector("#merch-swiper");
  if (merchEl) {
    var merchSwiper = new Swiper(
      merchEl,
      merchSwiperOptions(merchEl, "#merch-right", "#merch-left")
    );
    attachNavVisibility(merchSwiper);
  }

  document.querySelectorAll('[id^="related-products-swiper-"]').forEach(function (el) {
    var suffix = el.id.replace(/^related-products-swiper-/, "");
    var relSwiper = new Swiper(
      el,
      merchSwiperOptions(
        el,
        "#related-products-right-" + suffix,
        "#related-products-left-" + suffix,
        true
      )
    );
    attachNavVisibility(relSwiper);
  });

  document.querySelectorAll(".swiper-container.is-product-gallery").forEach(function (container) {
    var thumbEl = container.querySelector(".swiper.is-product-thumbnail");
    var galleryEl = container.querySelector(".swiper.is-product-gallery");
    var nextEl = container.querySelector(".swiper-next");
    var prevEl = container.querySelector(".swiper-prev");
    if (!thumbEl || !galleryEl) return;

    var thumbsSwiper = new Swiper(thumbEl, {
      slidesPerView: "auto",
      slideToClickedSlide: true,
      spaceBetween: "4%",
      watchSlidesProgress: true,
    });

    new Swiper(galleryEl, {
      mousewheel: {
        forceToAxis: true,
      },
      thumbs: {
        swiper: thumbsSwiper,
        slideThumbActiveClass: "is-active",
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  });
})();
